<template>
  <div>
    <div>
      <div class="header">
        <img class="header-img" src="https://spkg.smartmice.cn/resources/images/official/about/3.jpg">
        <div class="title">
          <div>联系我们</div>
          <img src="https://spkg.smartmice.cn/resources/images/official/common/downBtn.png">
        </div>
      </div>
      <div class="content">
        <div class="content-item">
          <div class="text">
            <h3>集团总部联系方式</h3>
            <ul>
              <li>
                <img src="https://spkg.smartmice.cn/resources/images/official/common/address.png" class="smallIcon">
                <span>北京市朝阳区广渠东路3号中水电国际大厦5层</span>
              </li>
              <li>
                <img src="https://spkg.smartmice.cn/resources/images/official/common/zipCode.jpg" class="smallIcon">
                <span>100124</span>
              </li>
              <li>
                <img src="https://spkg.smartmice.cn/resources/images/official/common/phone.jpg" class="smallIcon">
                <span>010-56399700</span>
              </li>
              <li style="margin-bottom: 25px">
                <img src="https://spkg.smartmice.cn/resources/images/official/common/email.jpg" class="smallIcon">
                <span>Marketing@smartmice.cn
                  <br>
                  <span style="margin-left: 32px">hr@smartmice.cn（HR邮箱）</span>
                </span>
              </li>
              <li style="margin-bottom: 25px">
                <img src="@/assets/img/common/weixin.png" class="smallIcon" />
                <img src="@/assets/img/about/wechat_qrcode.png" />
              </li>
            </ul>
          </div>
          <div class="map">
            <baidu-map :zoom="amap1.zoom" :scroll-wheel-zoom="true" :center="amap1.center" class="allmap">
              <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
              <bm-marker animation="BMAP_ANIMATION_BOUNCE" :position="amap1.marker.position" @click="amap1Click" :visible="amap1.marker.visible">
                <bm-info-window :position="amap1.window.position" @close="amap1Close" :show="amap1.window.show" title="中智国际商展集团" :width="amap1.window.width" :height="amap1.window.height">
                  <span>北京市朝阳区广渠东路3号中水电国际大厦5层</span>
                </bm-info-window>
              </bm-marker>
            </baidu-map>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from "@/components/Footer";
export default {
  name: "ContactUs",
  components: {
    Footer
  },
  data() {
    return {
      amap1: {
        zoom: 18,
        center: {lng: 116.50191, lat: 39.893716}, 
        marker: {
          position: {lng: 116.50191, lat: 39.893716},
          visible: true,
          draggable: false
        },
        window: {
          position: {lng: 116.50191, lat: 39.893716},
          show: false,
          width: 200,
          heigh: 100
        }
      },
    };
  },
  methods: {
    amap1Click() {
      this.amap1.window.show = true
    },
    amap1Close() {
      this.amap1.window.show = false
    }
  }
};
</script>
<style lang="less" scoped>
@media (min-width: 997px) {
  .content {
    padding: 80px 80px 100px 80px;
    .content-item {
      overflow: hidden;
      zoom: 1;
      height: 300px;
    }
    .text {
      width: 40%;
      float: left;
      padding-right: 40px;
    }
    .map {
      width: 60%;
      float: left;
    }
  }
  
}
@media (max-width: 997px) {
  .content {
    padding: 30px;
  }
}
.content {
  .content-item + .content-item {
    margin-top: 50px;
  }
}
.text {
  h3 {
    color: #717171;
    margin: 0;
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: normal;
  }
  .smallIcon {
    vertical-align: top;
    width: 14px;
    margin-top: 1px;
    margin-right: 15px;
  }
}
ul li {
  font-size: 14px;
  color: #717171;
  margin: 10px 0;
}
.map {
  position: relative;
  .allmap {
    width: 100%;
    height: 300px;
  }
}
</style>
